// extracted by mini-css-extract-plugin
export var carrierNotice = "_jv-5";
export var carrierNoticePlaceholder = "_jv-6";
export var deliveryRow = "_jv-c";
export var fixedHeight = "_jv-4";
export var freightLogo = "_jv-b";
export var fullWidth = "_jv-3";
export var priceColumn = "_jv-7";
export var radioSelected = "_jv-9";
export var radioUnselected = "_jv-8";
export var selectedOption = "_jv-2";
export var selectedOptionContainer = "_jv-1";
export var selection = "_jv-0";
export var tallSkeletonText = "_jv-a";